import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './TaskIntervenientsController.module.sass'
import useIntervenients from 'hooks/useIntervenients'

const TaskIntervenientsRow = (props) => {
	const { name, id, role, percentage } = props
	return (
		<HStack className={styles['intervenients-row']} gap='small'>
			<VStack>
				<HStack gap='xsmall'>
					<h5>{name}</h5>
					{id ? <small>{id}</small> : null}
				</HStack>
				<small>{role}</small>
			</VStack>
			<small className={styles['percentage']}>{percentage}%</small>
		</HStack>
	)
}

const TaskIntervenientsController = (props) => {
	const { requisition } = props
	const { i18n } = useGlobal()

	const {
		surgeon,
		assistant,
		anesthesiologist,
		instrumentalist,
		other,
		hasSurgeon,
		hasAssistant,
		hasAnesthesiologist,
		hasInstrumentalist,
		hasOther,
	} = useIntervenients(requisition)

	const hasIntervenient =
		hasSurgeon ||
		hasAssistant ||
		hasAnesthesiologist ||
		hasInstrumentalist ||
		hasOther

	return (
		<>
			{hasIntervenient && (
				<fieldset>
					<VStack className={styles['root']}>
						<h4>{i18n`Surgery team`}</h4>
						<VStack className={styles['intervenients-container']}>
							{hasSurgeon ? (
								<TaskIntervenientsRow
									name={surgeon}
									id={
										requisition.surgicalRequestAdmission
											?.intervenients?.surgeon?.id
									}
									role={i18n`Surgeon`}
									percentage={
										requisition.surgicalRequestAdmission
											?.intervenients?.surgeon?.percentage
									}
								/>
							) : null}

							{hasAssistant ? (
								<TaskIntervenientsRow
									name={assistant}
									id={
										requisition.surgicalRequestAdmission
											?.intervenients?.medicAssistant?.id
									}
									role={i18n`1º Assistant`}
									percentage={
										requisition.surgicalRequestAdmission
											?.intervenients?.medicAssistant
											?.percentage
									}
								/>
							) : null}

							{hasAnesthesiologist ? (
								<TaskIntervenientsRow
									name={anesthesiologist}
									role={i18n`Anesthesiologist`}
									percentage={
										requisition.surgicalRequestAdmission
											?.intervenients?.anesthesiologist
											?.percentage
									}
								/>
							) : null}

							{hasInstrumentalist ? (
								<TaskIntervenientsRow
									name={instrumentalist}
									role={i18n`Instrumentalist`}
									percentage={
										requisition.surgicalRequestAdmission
											?.intervenients?.instrumentalist
											?.percentage
									}
								/>
							) : null}

							{hasOther ? (
								<TaskIntervenientsRow
									name={other}
									role={i18n`Other`}
									percentage={
										requisition.surgicalRequestAdmission
											?.intervenients?.other?.percentage
									}
								/>
							) : null}
						</VStack>
					</VStack>
				</fieldset>
			)}
		</>
	)
}

export default TaskIntervenientsController
